import {connect} from "react-redux";
import {
  getProgramCounts,
} from '../actions/actions-reports-global';
import ProgramCounts from '../views/ProgramCounts/ProgramCounts';
const mapStateToProps = (state, ownProps) => {
  return {
    reportsGlobals: state.reportsGlobalsR,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getProgramCounts: (loginID) => {
      dispatch(getProgramCounts(loginID) );},
  };
};
const ProgramCountsContainer = connect(mapStateToProps, mapDispatchToProps)(ProgramCounts);
export default ProgramCountsContainer;
